import React, { useState } from 'react';
import FullscreenTextEditor from './FullscreenTextEditor';

/**
 * 描述词编辑弹窗 —— 点 T 角标直接进全屏编辑
 *
 * 素材的描述词会在连到下游生成节点时，整段作为提示词传给模型
 * （拼成 `图1是"标题"：描述`，见 useNodeActions.js）。
 *
 * 2026-09-30 改版：不再有中间小窗 + 全屏按钮的两层嵌套，
 * 点 T 角标直接进全屏（带文本整理 + 按住说话）。
 * 「完成」保存并关闭；「取消」/ Esc 关闭且不写回。
 *
 * @param {object} item - 素材对象（读 title / description）
 * @param {function} onSave - 保存回调，签名 (newDescription) => void
 * @param {function} onCancel - 取消回调
 */
export default function DescriptionEditModal({ item, onSave, onCancel }) {
  const [value, setValue] = useState(item?.description || '');

  if (!item) return null;

  const handleClose = () => {
    // 点「完成」：保存并关闭
    onSave(value.trim());
    onCancel();
  };

  return (
    <FullscreenTextEditor
      isOpen={true}
      onClose={handleClose}
      // 「取消」/ Esc：只关闭，不调 onSave —— 手滑清空内容还能反悔
      onDismiss={onCancel}
      value={value}
      onChange={setValue}
      title={`编辑描述词 — ${item.title || '未命名'}`}
      placeholder="描述这张图的内容，会作为提示词传给模型…"
    />
  );
}
